"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
/* eslint-disable no-useless-escape */

const validEmail = email => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email.toLowerCase());
};
const validDate = date => {
  // eslint-disable-next-line
  return !isNaN(Date.parse(date));
};
const validCustom = (customValue, customTest) => {
  if (customTest instanceof RegExp) {
    return customTest.test(customValue);
  } else if (typeof customTest === 'function') {
    return customTest(customValue);
  } else {
    console.log('customValidation needs to be a function or a Regex');
  }
};
const AREA_CODES = [{
  countryCode: 'ca',
  codes: [403, 587, 780, 825, 236, 250, 604, 672, 778, 204, 431, 506, 709, 782, 902, 226, 249, 289, 343, 365, 416, 437, 519, 548, 613, 647, 705, 807, 905, 367, 418, 438, 450, 514, 579, 581, 819, 873, 306, 639, 867]
}];
const validAreaCodes = (phoneValue, countryCodes) => {
  if (!countryCodes) {
    return true;
  }
  if (phoneValue.length <= 9) {
    return true;
  }
  if (!AREA_CODES.length) {
    console.error('Missing area codes');
    return true;
  }
  const selectedCodes = AREA_CODES.filter(areaCode => countryCodes.includes(areaCode.countryCode)).map(areaCode => areaCode.codes).flat();
  return selectedCodes.includes(Number(phoneValue.slice(0, 3)));
};

//Formating phone number value to prevent event.target.value to escape NumberFormat component formating
const formatPhoneNumber = val => {
  return val.match(/\d/g).join('');
};
const useFormElementValidation = (initialValue, options) => {
  const [errors, setErrors] = (0, _react.useState)({});
  const {
    customMessage: cMsg = {}
  } = options;
  const checkErrors = valueToTest => {
    const newErrors = [];
    if (options.required && typeof valueToTest === 'boolean' && !valueToTest) {
      cMsg.hasOwnProperty('required') ? newErrors.push(cMsg.required) : newErrors.push('This field is required');
    } else {
      if (options.required && (!valueToTest || valueToTest && valueToTest.length === 0)) {
        cMsg.hasOwnProperty('required') ? newErrors.push(cMsg.required) : newErrors.push('This field is required');
      }
      if (options.required && options.currency && valueToTest && +valueToTest === 0) {
        cMsg.hasOwnProperty('currency') ? newErrors.push(cMsg.currency) : newErrors.push('This field cannot be 0');
      }
      if (options.date && valueToTest && !validDate(valueToTest)) {
        cMsg.hasOwnProperty('date') ? newErrors.push(cMsg.date) : newErrors.push('Please enter a valid date');
      }
      if (options.validAreaCodeTo && valueToTest && !validAreaCodes(valueToTest, options.validAreaCodeTo)) {
        cMsg.hasOwnProperty('validAreaCodeTo') ? newErrors.push(cMsg.validAreaCodeTo) : newErrors.push('Please enter a valid area code');
      }
      if (options.email && valueToTest && !validEmail(valueToTest)) {
        cMsg.hasOwnProperty('email') ? newErrors.push(cMsg.email) : newErrors.push('Please enter a valid email');
      }
      if (options.number && valueToTest && options.max < +valueToTest) {
        cMsg.hasOwnProperty('number') ? newErrors.push(cMsg.number) : newErrors.push("Too much, max " + options.max);
      }
      if (options.number && valueToTest && options.min > +valueToTest) {
        cMsg.hasOwnProperty('number') ? newErrors.push(cMsg.number) : newErrors.push("Not enough, min " + options.min);
      }
      if (options.maxChar && valueToTest && valueToTest.length > options.maxChar) {
        cMsg.hasOwnProperty('maxChar') ? newErrors.push(cMsg.maxChar) : newErrors.push("Please type at most " + options.maxChar + " characters");
      }
      if (options.atLeast && valueToTest && valueToTest.length < options.atLeast) {
        cMsg.hasOwnProperty('atLeast') ? newErrors.push(cMsg.atLeast) : newErrors.push("Please choose at least " + options.atLeast + " options");
      }
      if (options.atMost && valueToTest && valueToTest.length > options.atMost) {
        cMsg.hasOwnProperty('atMost') ? newErrors.push(cMsg.atMost) : newErrors.push("Please choose at most " + options.atMost + " options");
      }
      if (options.tel && valueToTest && formatPhoneNumber(valueToTest).length < 10) {
        cMsg.hasOwnProperty('tel') ? newErrors.push(cMsg.tel) : newErrors.push("Please enter a valid phone number. " + (10 - valueToTest.length) + " numbers left");
      }
      if (options.customValidation && valueToTest && !validCustom(valueToTest, options.customValidation)) {
        cMsg.hasOwnProperty('customValidation') ? newErrors.push(cMsg.customValidation) : newErrors.push('This field does not match expectations');
      }
      if (options.customInvalidation && valueToTest && validCustom(valueToTest, options.customInvalidation)) {
        cMsg.hasOwnProperty('customInvalidation') ? newErrors.push(cMsg.customInvalidation) : newErrors.push('This field does not match expectations');
      }
    }
    setErrors(newErrors);
  };
  const handleDateChange = date => checkErrors(date);
  const handleChangeRadioGroup = (id, RadioGroupOptions) => {
    const radioChecked = RadioGroupOptions.filter(radio => id === radio.id);
    checkErrors(radioChecked.length ? radioChecked[0].value : undefined);
  };
  const handleChangeCheckboxGroup = CheckboxGroupChecked => checkErrors(CheckboxGroupChecked);
  const handleValueChange = event => {
    const val = event && event.target ? event.target.value // when an event is passed
    : event; // when it's the value itself that is passed
    checkErrors(val);
  };
  const handleCheck = event => {
    event.persist();
    checkErrors(event.target.checked);
  };
  const handleInput = event => errors.length && checkErrors(event.target.value);
  return [
  // returnedValue,
  errors, {
    onChange: handleValueChange,
    onInput: handleInput,
    onClick: handleCheck,
    onSelect: handleValueChange,
    onBlur: handleValueChange,
    onChangeCheckbox: handleCheck,
    onChangeCheckboxGroup: handleChangeCheckboxGroup,
    onChangeRadio: handleCheck,
    onChangeRadioGroup: handleChangeRadioGroup,
    onChangeDate: handleDateChange
  }];
};
var _default = exports.default = useFormElementValidation;